import {
  Bounds,
	MapFilter,
	MapLegend
}											from '../'
import {
  ConfigService,
  MapService
} from '../../';

declare var google:						any
declare var MarkerClusterer:	any

export class MapLayer {
	private layerIndex			= 0
	private loadingTracker	= 0
	private markerClusterer = null

  public coordinates:	any = {}
  public tempCoordinates: any = {};
	public currentRes		= ''
	public filter:			MapFilter
	public filterText		= '';
	public legend:			MapLegend[] = []
	public name = '';
	public properties:	any = {}
	public resolutions:	string[] = []
	public type					= ''

  selectedMarker: any = null;
  oldIcon: any = null;

  zoomChanged = false;

	constructor(data: any, layerIndex: number, public done: () => void, public configService: ConfigService, public mapService: MapService) {
		if (Array.isArray(data.resolutions)) {
      data.resolutions = [ '100' ];
			for (var i = 0, len = data.resolutions.length; i < len; i++) {
				this.resolutions.push(data.resolutions[i])

				if (i === len - 1) {
					this.currentRes = data.resolutions[i]
				}
			}
    }

		if (typeof data.name === 'string') {
			this.name = data.name;
		}

		if (typeof data.type === 'string') {
			this.type = data.type
		}

		if (typeof data.filter === 'string') {
			this.filterText = data.filter;
		}

    setTimeout((backendService, t) => {
      backendService.getMapCoordinates(data.name, t.currentRes, t.gotMapCoordinates, t);
    }, 100, mapService.backendService, this);
    
    if (data.resolutions.length > 1) {
      for (var i = 0, leni = data.resolutions.length - 1; i < leni; i++) {
        setTimeout((backendService, i2) => {
          backendService.getMapCoordinates(data.name, data.resolutions[i2], this.gotMapCoordinates, this);
        }, 2000, mapService.backendService, i);
      }
    }

    this.layerIndex = layerIndex;

    this.gotMapProperties(data);

    this.mapService.popup.subscribe(data => {this.gotPopup(data); });
	}

  gotPopup(text: string)  {
    if (text.length === 0 && this.selectedMarker) {
      this.selectedMarker.setIcon(this.oldIcon);
      this.selectedMarker.setZIndex(this.layerIndex);
      this.selectedMarker = null;
    }
  }

	doneLoading() {
		if (++this.loadingTracker === 2) {
      this.done.call(this.mapService);
		}
  }
  
  checkBounds(bounds: Bounds, zoom) {
    if (this.coordinates[this.currentRes]) {
      if (this.coordinates[this.currentRes][0]._bounds) {
        for (var i = 0; i < this.coordinates[this.currentRes].length; i++) {
          if (this.coordinates[this.currentRes][i]._bounds.x1 < bounds.maxLng &&
            this.coordinates[this.currentRes][i]._bounds.x2 > bounds.minLng &&
            this.coordinates[this.currentRes][i]._bounds.y1 < bounds.maxLat &&
            this.coordinates[this.currentRes][i]._bounds.y2 > bounds.minLat) {
            if (!this.coordinates[this.currentRes][i]._isVisible || this.zoomChanged) {
              this.coordinates[this.currentRes][i]._isVisible = true;
              if (this.coordinates[this.currentRes][i]._single) {
                this.coordinates[this.currentRes][i].setPath(this.getSimplifiedCoordinates(this.tempCoordinates[this.currentRes][i], zoom, bounds.lngpp, bounds.latpp));
              } else {
                this.coordinates[this.currentRes][i].setPaths(this.getSimplifiedCoordinates(this.tempCoordinates[this.currentRes][i], zoom, bounds.lngpp, bounds.latpp, false));
              }
            }
          } else {
            if (this.coordinates[this.currentRes][i]._isVisible) {
              this.coordinates[this.currentRes][i]._isVisible = false;
              if (this.coordinates[this.currentRes][i]._single) {
                this.coordinates[this.currentRes][i].setPath([]);
              } else {
                this.coordinates[this.currentRes][i].setPaths([]);
              }
            }
          }
        }

        this.zoomChanged = false;
      }
    }
  }

  getSimplifiedCoordinates(coords: any, zoom: any, lngpp, latpp, single = true) {
    var temp = [], current = null;

    if (zoom > 16) {
      return coords;
    }

    if (single) {
      for (var i = 0; i < coords.length; i++) {
        if (current === null) {
          temp.push(coords[i]);
          current = coords[i];
        } else if (Math.abs(coords[i].lng - current.lng) > lngpp || Math.abs(coords[i].lat - current.lat) > latpp) {
          temp.push(coords[i]);
          current = coords[i];
        }
        //i += 9;
      }
    } else {
      for (var i = 0; i < coords.length; i++) {
        if (Array.isArray(coords[i])) {
          temp.push([]);
          current = null;
          for (var j = 0; j < coords[i].length; j++) {
            if (current === null) {
              temp[temp.length - 1].push(coords[i][j]);
              current = coords[i][j];
            } else if (Math.abs(coords[i][j].lng - current.lng) > lngpp || Math.abs(coords[i][j].lat - current.lat) > latpp) {
              temp[temp.length - 1].push(coords[i][j]);
              current = coords[i][j];
            }
            //j += 9;
          }
        } else {
          if (current === null) {
            temp.push(coords[i]);
            current = coords[i];
          } else if (Math.abs(coords[i].lng - current.lng) > lngpp || Math.abs(coords[i].lat - current.lat) > latpp) {
            temp.push(coords[i]);
            current = coords[i];
          }
          //i += 9;
        }
      }
    }

    return temp;
  }

	getMarkers(coordinates: number[][]): any[] {
		var temp: any[] = []

		for (var i = 0, len = coordinates.length; i < len; i++) {
			let marker = new google.maps.Marker({
				icon:			{
					url:				this.configService.getImage(this.properties.details[0]),
					scaledSize: new google.maps.Size(this.properties.details[1], this.properties.details[2]),
          anchor:     new google.maps.Point(this.properties.details[1] / 2, this.properties.details[2] - 5)
				},
				position: { lat: coordinates[i][1] / 100000, lng: coordinates[i][0] / 100000 },
				zIndex: 	this.layerIndex
			})

			marker.title = this.layerIndex + '.' + i

      temp.push(marker)
      
      //marker.setMap(this.mapService.map);

			marker.addListener('click', () => {
				let
				layer		= parseInt(marker.title.substring(0, marker.title.indexOf('.'))),
				feature	= parseInt(marker.title.substring(marker.title.indexOf('.') + 1, marker.title.length))

				this.mapService.getProperties(this.mapService.layers[layer].name, feature, (properties: string[]) => {
					var html = '';

					for (var i = 0, len = properties.length; i < len; i++) {
            let propertyName = this.mapService.layers[layer].properties.properties[i].replace('_', ' ');

            if (propertyName === 'Name') {
              html = '<h1>' + properties[i] + '</h1>'
            } else if (propertyName === 'link') {
						  html += '<p><a href="' + properties[i] + '" target="_blank"><img style="transform:translate3d(0, 6px, 0);" src="' + this.configService.getImage('pvpopup') + '" /></a><span style="display:inline-block;border-left:1px solid RGB(214, 214, 214);padding-left:10px;margin-left:12px;"><b>Want to find out more?</b><br>Visit the PowerVision website</span></p>';
            } else if (properties[i] !== null) {
						  html += '<p>' + (this.name !== 'sites' ? '<b>' + propertyName + ' : </b>' : '') + properties[i] + '</p>';
            }
					}

          this.mapService.popup.next(''); // Might want better way to make sure there are no doubles

					this.mapService.popup.next('<style>* { font-size: ' + (this.configService.mobile ? '10' : '14') + 'px; } h1 { color: ' + this.configService.getColor(0, '#000') + '; margin-bottom: ' + (this.configService.mobile ? '10' : '20') + 'px; font-size: ' + (this.configService.mobile ? '14' : '18') + 'px; }</style>' + html);

          if (this.properties.details.length > 3) {
            this.selectedMarker = marker;
            this.oldIcon = marker.icon;

            marker.setIcon({
              url:				this.configService.getImage(this.properties.details[this.properties.details.length - 3]),
              scaledSize: new google.maps.Size(this.properties.details[this.properties.details.length - 2], this.properties.details[this.properties.details.length - 1]),
              anchor:     new google.maps.Point(this.properties.details[this.properties.details.length - 2] / 2, this.properties.details[this.properties.details.length - 1] - 5)
            });

            marker.setZIndex(1000);
          }
				}, this);
			})
		}

		if (this.properties.details.length > 6) {
			this.loadingTracker--;

				this.markerClusterer = new MarkerClusterer(this.mapService.map, temp, {
					ignoreHidden:				true,
					minimumClusterSize:	2,
					styles: [{
						height:			this.properties.details[5],
            textColor: 	'#FFFFFF',
						url:				this.configService.getImage(this.properties.details[3]),
						width:			this.properties.details[4]
					}]
				})

				this.doneLoading()
		}

		return temp
	}

	getMultiPolygons(coordinates: number[][][][], res: string) {
		var temp: any[] = []
    var x1 = 0, x2 = 0, y1 = 0, y2 = 0, tx = 0, ty = 0;

		for (var i = 0, leni = coordinates.length; i < leni; i++) {
			for (var j = 0, ci = coordinates[i], lenj = ci.length; j < lenj; j++) {
				var
				coords: any[] = [],
				single = false;
        x1 = null;
        x2 = null;
        y1 = null;
        y2 = null;

				for (var k = 0, cj = ci[j], lenk = cj.length; k < lenk; k++) {
          var coords2: any[] = []
          
					if (typeof cj[k][0] === 'number') {
            tx = cj[k][0] / 100000;
            ty = cj[k][1] / 100000;

            if (x1 === null || x1 > tx) {
              x1 = tx;
            }

            if (x2 === null || x2 < tx) {
              x2 = tx;
            }

            if (y1 === null || y1 > ty) {
              y1 = ty;
            }

            if (y2 === null || y2 < ty) {
              y2 = ty;
            }

						coords.push({ lat: ty, lng: tx })
						single = true
					} else {
						for (var l = 0, ck = cj[k], lenl = ck.length; l < lenl; l++) {
              tx = ck[l][0] / 100000;
              ty = ck[l][1] / 100000;

              if (x1 === null || x1 > tx) {
                x1 = tx;
              }

              if (x2 === null || x2 < tx) {
                x2 = tx;
              }

              if (y1 === null || y1 > ty) {
                y1 = ty;
              }

              if (y2 === null || y2 < ty) {
                y2 = ty;
              }

							coords2.push({ lat: ty, lng: tx })
						}
					}

					if (!single) {
						coords.push(coords2)
					}
				}
      
        if (!Array.isArray(this.tempCoordinates[res])) {
          this.tempCoordinates[res] = [];
        }
  
        this.tempCoordinates[res].push(coords);

				let polygon = new google.maps.Polygon(single ? {
					fillColor:		Array.isArray(this.properties.details[0]) ? this.properties.details[0][i] : this.properties.details[0],
					fillOpacity:	this.properties.details[2],
					path:					coords,
					strokeColor:	Array.isArray(this.properties.details[0]) ? this.properties.details[0][i] : this.properties.details[0],
					strokeWeight:	this.properties.details[1],
					zIndex: 			this.layerIndex
				}: {
					fillColor:		Array.isArray(this.properties.details[0]) ? this.properties.details[0][i] : this.properties.details[0],
					fillOpacity:	this.properties.details[2],
					paths:				coords,
					strokeColor:	Array.isArray(this.properties.details[0]) ? this.properties.details[0][i] : this.properties.details[0],
					strokeWeight:	this.properties.details[1],
					zIndex: 			this.layerIndex
				})

        polygon.title = this.layerIndex + '.' + i
        
        polygon._bounds = { x1: x1, x2: x2, y1: y1, y2: y2 };
        polygon._single = single;
        polygon._isVisible = true;

				temp.push(polygon)
			}
		}

		return temp
	}

	getPolygons(coordinates: number[][][][], res: string) {
    var temp: any[] = []
    var x1 = 0, x2 = 0, y1 = 0, y2 = 0, tx = 0, ty = 0;

		for (var i = 0, leni = coordinates.length; i < leni; i++) {
      var coords: any[] = []
      x1 = null;
      x2 = null;
      y1 = null;
      y2 = null;

			for (var j = 0, ci = coordinates[i], lenj = ci.length; j < lenj; j++) {
				for (var k = 0, cj = ci[j], lenk = cj.length; k < lenk; k++) {
          tx = cj[k][0] / 100000;
          ty = cj[k][1] / 100000;
          coords.push({ lat: ty, lng: tx })

          if (x1 === null || x1 > tx) {
            x1 = tx;
          }

          if (x2 === null || x2 < tx) {
            x2 = tx;
          }

          if (y1 === null || y1 > ty) {
            y1 = ty;
          }

          if (y2 === null || y2 < ty) {
            y2 = ty;
          }
				}
      }
      
      if (!Array.isArray(this.tempCoordinates[res])) {
        this.tempCoordinates[res] = [];
      }

      this.tempCoordinates[res].push(coords);

			let polygon = new google.maps.Polygon({
				fillOpacity:	this.properties.details[2],
				path:					coords,
				strokeColor:	this.properties.details[0],
				strokeWeight:	this.properties.details[1],
				zIndex: 			this.layerIndex
			})

      polygon.title = this.layerIndex + '.' + i
      
      polygon._bounds = { x1: x1, x2: x2, y1: y1, y2: y2 };
      polygon._single = true;
      polygon._isVisible = true;

      temp.push(polygon)
    }

		return temp
  }

	getPolylines(coordinates: number[][][], res: string) {
		var temp: any[] = []
    var x1 = 0, x2 = 0, y1 = 0, y2 = 0, tx = 0, ty = 0;

		for (var i = 0, leni = coordinates.length; i < leni; i++) {
			var coords: any[] = []
      x1 = null;
      x2 = null;
      y1 = null;
      y2 = null;

			for (var j = 0, ci = coordinates[i], lenj = ci.length; j < lenj; j++) {
        tx = ci[j][0] / 100000;
        ty = ci[j][1] / 100000;
				coords.push({ lat: ci[j][1] / 100000, lng: ci[j][0] / 100000 })

        if (x1 === null || x1 > tx) {
          x1 = tx;
        }

        if (x2 === null || x2 < tx) {
          x2 = tx;
        }

        if (y1 === null || y1 > ty) {
          y1 = ty;
        }

        if (y2 === null || y2 < ty) {
          y2 = ty;
        }
			}
      
      if (!Array.isArray(this.tempCoordinates[res])) {
        this.tempCoordinates[res] = [];
      }

      this.tempCoordinates[res].push(coords);

			let polyline = new google.maps.Polyline({
				path:					coords,
				strokeColor:	this.properties.details[0],
				strokeWeight:	this.properties.details[1],
				zIndex: 			this.layerIndex
			})

      polyline.title = this.layerIndex + '.' + i
      
      polyline._bounds = { x1: x1, x2: x2, y1: y1, y2: y2 };
      polyline._single = true;
      polyline._isVisible = true;

			temp.push(polyline)
		}

		return temp
	}

	gotMapCoordinates(coordinates: any[], res: string) {
		if (Array.isArray(coordinates)) {
			if (this.type === 'point') {
				this.coordinates[res] = this.getMarkers(coordinates)
			} else if (this.type === 'line') {
				this.coordinates[res] = this.getPolylines(coordinates, res)
			} else if (this.type === 'border') {
        this.coordinates[res] = this.getPolygons(coordinates, res)
			} else if (this.type === 'multiBorder') {
				this.coordinates[res] = this.getMultiPolygons(coordinates, res)
			} else {
				this.coordinates[res] = []
			}
		}

		this.doneLoading()
	}

	gotMapProperties(properties: any) {
		if (typeof properties === 'object') {
			this.properties = properties
		}

		this.doneLoading()
	}

	setFeatures(toggled: boolean) {
		if (toggled) {
      if (this.markerClusterer !== null) {
        this.markerClusterer.addMarkers(this.coordinates[this.currentRes]);
      } else {
        for (var i = 0, len = this.coordinates[this.currentRes].length; i < len; i++) {
          this.coordinates[this.currentRes][i].setMap(this.mapService.map);
          this.coordinates[this.currentRes][i].setVisible(true);
        }
      }
		} else {
			if (this.markerClusterer !== null) {
				this.markerClusterer.clearMarkers();
			} else {
				for (var i = 0, len = this.coordinates[this.currentRes].length; i < len; i++) {
          this.coordinates[this.currentRes][i].setMap(null);
        }
			}
		}
	}

  updateResolution(zoom: number) {
    var newRes = '';

    if (zoom > 10) {
      newRes = this.resolutions[0];
    } else if (zoom > 7) {
      newRes = this.resolutions[1];
    } else {
      newRes = this.resolutions[2];
    }

    if (this.filter && this.coordinates[newRes] !== undefined) {
      if (this.filter.toggled && this.currentRes !== newRes) {
        this.setFeatures(false);

        this.currentRes = newRes;

        this.setFeatures(true);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/electraLib/model/map/mapLayer.ts